import { rem } from 'polished'
import { css } from 'styled-components'
import { mediaHoverable } from 'lib/theme/mediaQueries'

/** Shared by the New chat and Search chats rows, laid out like a medium LuxKit list item. */
export const tripPlannerNavigationRowStyle = css`
  display: flex;
  align-items: center;
  gap: ${rem(12)};
  inline-size: 100%;
  padding-block: ${rem(8)};
  padding-inline: ${rem(16)};
  border-radius: ${props => props.theme.borderRadius.S};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  color: ${props => props.theme.palette.neutral.surface.normalContrast};
  transition: background-color 200ms;

  ${mediaHoverable} {
    &:hover {
      background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    }
  }
`
